export const styles = {
  root: {
    width: '840px',
    borderRadius: '4px',
    background: 'var(--white)',
    margin: 'auto',
  },
  wrapper: {
    display: 'flex',
  },
  aside: {
    width: '340px',
    padding: '48px 0',
    backgroundColor: 'var(--fill-cards)',
  },
  section: {
    width: 'calc(100% - 340px)',
    padding: '24px',
  },
  buttons: {
    paddingTop: '24px',
    borderTop: '1px solid var(--fill-cards)',
  },
  tableHeader: {
    padding: '6px 12px',
    backgroundColor: '#FAFAFA',
    borderBottom: '1px solid var(--fill-cards)',
    '.MuiFormControlLabel-label': {
      marginLeft: '8px',
    },
  },
  sortableItem: {
    width: '50%',
    borderBottom: '1px solid #EEE',
    padding: '6px 0',
    display: 'flex',
    cursor: 'move',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'white',
  },
  dragItem: {
    color: '#BDBDBD',
  },
}
